// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__zrlJN","label":"Completed_label__2kwcz"};